import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Redirect, useParams } from 'react-router-dom';

import {
  ROUTE_LOGIN,
  ROUTE_SCANBAT,
  ROUTE_SCANBAT_LOGIN,
  ROUTE_STANDALONE,
  ROUTE_STANDALONE_LOGIN,
  ROUTE_SUPPLIER,
} from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';

const PrivateRouteRedirect = ({ location }) => {
  const { logoutError } = useAuth();
  const params = useParams();

  const getPathname = useCallback(
    (localLocation) => {
      if (localLocation.pathname.includes(ROUTE_SCANBAT)) {
        return ROUTE_SCANBAT_LOGIN;
      }

      if (localLocation.pathname.includes(ROUTE_STANDALONE)) {
        return ROUTE_STANDALONE_LOGIN;
      }

      if (
        localLocation.pathname.startsWith(ROUTE_SUPPLIER) &&
        params.slug !== undefined
      ) {
        return `${ROUTE_SUPPLIER}/${params.slug}/login`;
      }

      return ROUTE_LOGIN;
    },
    [params],
  );

  return (
    <Redirect
      to={{
        // Redirect to standalone login if origin route is standalone mode
        pathname: getPathname(location),
        state: !logoutError ? { from: location } : {},
      }}
    />
  );
};

PrivateRouteRedirect.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default PrivateRouteRedirect;
